var React = require('react');

function CrossGrey (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m209.34 225.49q-10.12-10.71-20.29-21.39 12.12-12.82 24.22-25.66a4.31 4.31 0 0 0 -1.52-6.94 3.65 3.65 0 0 0 -3.87 1q-12.23 12.84-24.41 25.72-12.21-12.86-24.42-25.72a3.65 3.65 0 0 0 -3.87-1 4.31 4.31 0 0 0 -1.52 6.94q12.1 12.84 24.22 25.66-10.15 10.69-20.29 21.39c-1.32 1.39-2.75 2.74-4 4.22a4.31 4.31 0 0 0 1.64 6.83l.26.09a3.69 3.69 0 0 0 4-1.14c.62-.73 1.23-1.45 1.87-2.12q11.08-11.66 22.14-23.36 11.06 11.69 22.13 23.36c.64.67 1.25 1.39 1.87 2.12a3.69 3.69 0 0 0 4 1.14l.26-.09a4.31 4.31 0 0 0 1.64-6.83c-1.31-1.48-2.74-2.83-4.06-4.22z","fill":"#dddac7"}));
}

CrossGrey.defaultProps = {"viewBox":"0 0 410 405"};

module.exports = CrossGrey;

CrossGrey.default = CrossGrey;
